import { htmlToText } from "@sinch/utils/dom";
import { InferType, object, string } from "yup";

export const messageSchema = ({ defaultMessage }: { defaultMessage?: string }) =>
  object()
    .shape({
      textMessage: string()
        .transform((value) => htmlToText(value))
        .required()
        .smsMessage()
        .default(defaultMessage ?? ""),
    })
    .test("recipients-not-empty", function () {
      // Get recipients from context
      const recipients = this.options.context?.recipients;

      // Check if recipients exist and are not empty
      return recipients && Array.isArray(recipients) && recipients.length > 0;
    });

export type MessageFormFields = InferType<ReturnType<typeof messageSchema>>;
